import { Link } from 'react-router-dom'
import { Fragment } from 'react'

interface BreadcrumbPath {
  path: string
  label: string
}

interface BreadcrumbProps {
  paths: BreadcrumbPath[]
}

function Breadcrumb({ paths }: BreadcrumbProps): JSX.Element {
  if (!paths.length) return <></>

  return (
    <nav className="flex items-center !text-base text-primaryText mb-4">
      {paths.map((item, index) => {
        const isLast = index === paths.length - 1

        return (
          <Fragment key={item.path}>
            {isLast ? (
              <span className="font-semibold text-interaction hover:text-interactionHover">{item.label}</span>
            ) : (
              <>
                <Link to={item.path} className="hover:underline">
                  {item.label}
                </Link>
                <span className="mx-2">/</span>
              </>
            )}
          </Fragment>
        )
      })}
    </nav>
  )
}

export default Breadcrumb
